<template>
  <section>
    <div class="page">
      <div>
        <h2>
          Making video calls
        </h2>
        <p>
          Video calling lets you video call your contacts using ToTok. On
          iPhone, video calling is only available on iOS 9+. If your phone's
          operating system isn't supported, video calling won't be available to
          you.
        </p>
        <h6>
          Note: Make sure you have a strong Internet connection when placing or
          receiving video calls. A poor or improperly configured connection
          might result in poor video and audio quality. If you're connected to
          Wi-Fi, your video call quality is dependent on your wireless network
          signal and network data speed.
        </h6>
        <h3>
          To place a voice call
        </h3>
        <ol>
          <li>
            Open the chat with the contact you want to video call.
          </li>
          <li>
            Tap Video Call
            <img
              src="https://static.totok.ai/official/videocall.png"
              width="30px"
              height="20px"
            />
          </li>
        </ol>
        <h3>
          Receiving a video call
        </h3>
        <p>
          You'll see an incoming encrypted ToTok Video screen when someone video
          calls you, where you can:
        </p>
        <ol>
          <li>
            Tap
            <img
              src="https://static.totok.ai/official/videocall.png"
              width="30px"
              height="20px"
            />
            to accept the call
          </li>
          <li>
            Or tap
            <img
              src="https://static.totok.ai/official/decline.png"
              width="20px"
              height="20px"
            />
            to decline the call.
          </li>
        </ol>
        <h3>
          Switching between voice and video calls
        </h3>
        <p>
          To switch from a voice call to a video call:
        </p>
        <ol>
          <li>
            While on the voice call, tap video call
            <img
              src="https://static.totok.ai/official/videocall.png"
              width="30px"
              height="20px"
            />.
          </li>
          <li>
            The contact you're voice calling will see a request to switch to a
            video call and can accept or decline the switch.
          </li>
        </ol>
        <p>
          To switch from a video call to a voice call:
        </p>
        <ol>
          <li>
            While on the video call, tap voice call
            <img
              src="https://static.totok.ai/official/voicecall.png"
              width="20px"
              height="20px"
            />, which will notify the contact you're video calling.
          </li>
          <li>
            Once you turn the video off, the call will be switched to a voice
            call.
          </li>
        </ol>
        <h3>
          Making a group video call
        </h3>
        <p>
          To make a group video call:
        </p>
        <ol>
          <li>
            Go to the group you want to call.
          </li>
          <li>
            Tap New Call
            <img
              src="https://static.totok.ai/official/voicecall.png"
              width="20px"
              height="20px"
            />
            at the top right.
          </li>
          <li>
            Search for or select the contacts you want to add to the call.
          </li>
          <li>Tap <strong>Video Call</strong>.</li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
